import React from 'react';
import PropTypes from 'prop-types';
import styles from '../QuestionDisplay.scss';
import { t } from '../../../services/i18nService';

import stateCacheService from '../../../services/StateCache';
import storeManager from '../../../store/StoreManager';
import itemFlagActions from '../../../actions/ItemFlagActions';
import scorableItemNumberingService from '../../../services/questionView/ScorableItemNumberingService';
import flaggedItemsReader from '../../../store/readHelpers/FlaggedItemsReader';

const HiddenItemFlagButton = ({ orderNumber, contentRevisionId, responseIdentifier }) => {
    const { dispatch } = storeManager.getStore();
    const identifierSuffix = orderNumber ? `-${orderNumber}` : '';
    const identifier = `${contentRevisionId}${identifierSuffix}`;
    const isItemFlagged = flaggedItemsReader.isItemFlagged(identifier);

    const setFocusedFlag = () => {
        dispatch(
            itemFlagActions.focusItemFlag(identifier),
        );

        scorableItemNumberingService.navigateToScorableItem(contentRevisionId, responseIdentifier, undefined, true);
    };

    const clearFocusedFlag = () => {
        dispatch(
            itemFlagActions.focusItemFlag(null),
        );
    };

    const toggleFlag = () => {
        dispatch(
            itemFlagActions.toggleItemFlag(identifier, !isItemFlagged),
        );

        const state = storeManager.getState();
        const stateCache = stateCacheService.getStateCacheInstance();
        stateCache.setFlaggedItems(state.itemFlag.flaggedItems);
    };

    return (
        <button
            onClick={toggleFlag}
            onFocus={setFocusedFlag}
            onBlur={clearFocusedFlag}
            aria-pressed={isItemFlagged}
            className={styles.hiddenFocus}
            id={identifier}
        >
            <span className="sr-only">
                {isItemFlagged
                    ? `${t('question.unflagQuestionNumber')} ${orderNumber}`
                    : `${t('question.flagQuestionNumber')} ${orderNumber}`
                }
            </span>
        </button>
    );
};

HiddenItemFlagButton.propTypes = {
    orderNumber: PropTypes.string,
    contentRevisionId: PropTypes.number.isRequired,
    responseIdentifier: PropTypes.string.isRequired,
};

export default HiddenItemFlagButton;
